import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/module'

import BrandGroupEditRoutes from './routes'

const BrandGroupEdit = () => {
  const { brandGroupId } = useNumericParams()

  useReduxAction(
    'brandGroups',
    'loadBrandGroup',
    {
      entityId: brandGroupId,
      include_brand_group_brand: true,
      include_brand_logo: true,

    },
    [brandGroupId],
    {
      dispatchAction: (action: Function, requestOptions) => action(brandGroupId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!brandGroupId && !loading,
    },
  )

  return (
    <BrandGroupEditRoutes />
  )
}

export default BrandGroupEdit
